import Flip from './Flip';

document.addEventListener('DOMContentLoaded', () => {

  const flipElement = document.querySelectorAll('.js-flip');
  if (!flipElement.length) {

    return;
  }

  flipElement.forEach((element) => {
    const flip = new Flip(element);
    flip.mount(element);
  })
});
